<template>
    <div class="flexcol-fill overflow-hidden">
        <v-container fluid class="flexcol-fix">
            <v-tabs v-model="selectedTab">
                <v-tab value="plan">Planen</v-tab>
                <v-tab value="pool">Gerichte-Pool <v-chip class="ml-1">{{ pool.gerichte.length }}</v-chip></v-tab>
            </v-tabs>
        </v-container>
        <v-tabs-window v-model="selectedTab" class="flexcol-fill overflow-hidden">
            <v-tabs-window-item value="plan" class="flexcol-fill overflow-hidden">
                <v-container fluid class="flexcol-fill overflow-auto text-light pl-3 pt-0 pr-3 pb-3">
                    <v-row no-gutters>
                        <v-col v-if="pool.gerichte >= 25" class="text-center">
                            <v-btn color="primary" @click="openWizard"><v-icon icon="mdi-auto-fix" class="mr-2"/>Automatisch für Tage planen...</v-btn>
                        </v-col>
                        <v-col v-else>
                            <v-alert type="warning" class="pa-2 text-sm">
                                Es müssen mindestens 25 Gerichte im Pool vorhanden sein, um automatisch für Tage zu planen.
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-for="t in tage" v-bind:key="t.Id" no-gutters :class="(t.istWochenende ? 'bg-surface-lighten-1' : 'bg-surface-lighten-2') + ' pt-2 pb-2 border-light border-b-sm border-opacity-100'" align="center">
                        <v-col cols="auto">
                            <span class="text-l mr-3">{{ $dayjs(t.Datum).format('dd') }}</span>
                            <span class="text-l mr-3">{{ $dayjs(t.Datum).format('DD. MMM') }}</span>
                        </v-col>
                        <v-col>
                            <span v-if="t.Gericht !== null"></span>
                            <span v-else class="text-light-darken-3">(noch kein Gericht geplant)</span>
                        </v-col>
                        <v-col v-if="1 == 2" cols="auto">
                            <v-menu>
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" append-icon="mdi-chevron-down" color="secondary"><v-icon icon="mdi-pen"/></v-btn>
                                </template>
                                <v-list color="secondary">
                                    <v-list-item title="Auswählen aus Gerichte-Pool..."/>
                                    <v-list-item title="Automatische Auswahl"/>
                                </v-list>                                
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-tabs-window-item>
            <v-tabs-window-item value="pool" class="flexcol-fill overflow-hidden">
                <v-container fluid class="pa-0">
                    <v-row align="center">
                        <v-col class="pl-2" cols="auto">
                            <v-btn @click="neuesGericht" color="success"><v-icon icon="mdi-plus-circle-outline mr-3"/> Neues Gericht anlegen</v-btn>                            
                        </v-col>
                        <v-col>
                            <v-text-field dense hide-details solo-inverted prepend-inner-icon="mdi-magnify" label="Suche" v-model="pool.suche"/>
                        </v-col>
                    </v-row>
                </v-container>
                <div class="flexcol-fill overflow-auto">
                    <v-container fluid class="pa-0">
                        <v-row v-if="poolGerichteGefiltert.length == 0">
                            <v-col>
                                <v-alert density="compact" class="mt-2">
                                    <span v-if="pool.gerichte.length == 0"><v-icon icon="mdi-information-outline"/> Noch keine Gerichte im Pool vorhanden.</span>
                                    <span v-else><v-icon icon="mdi-information-outline"/> Kein Gericht entspricht der Suche.</span>
                                </v-alert>
                            </v-col>
                        </v-row>             
                        <v-row v-for="g in poolGerichteGefiltert" v-bind:key="g.Id" align="center" class="ml-3 mt-2 mr-3 mb-2 pt-1 pb-1 border-light border-b-sm border-opacity-100">
                            <v-col cols="auto">
                                <v-btn color="secondary" icon="mdi-pen" size="small" @click="gerichtBearbeiten(g)"/>
                                <v-btn color="error" icon="mdi-trash-can-outline" size="small" class="ml-2" @click="gerichtLoeschen(g)"/>
                            </v-col>
                            <v-col>
                                {{ g.Bezeichnung }} 
                            </v-col>
                            <v-col cols="auto">
                                <v-icon icon="mdi-star" role="button" @click="sterneSetzen(g, 1)"/>
                                <v-icon icon="mdi-star" role="button" v-if="g.Sterne >= 2" class="ml-2 text-white" @click="sterneSetzen(g, 2)"/>
                                <v-icon icon="mdi-star" role="button" v-else class="ml-2 text-light opacity-50" @click="sterneSetzen(g, 2)"/>
                                <v-icon icon="mdi-star" role="button" v-if="g.Sterne == 3" class="ml-2 text-white" @click="sterneSetzen(g, 3)"/>
                                <v-icon icon="mdi-star" role="button" v-else class="ml-2 text-light opacity-50" @click="sterneSetzen(g, 3)"/>
                            </v-col>
                        </v-row>
                    </v-container> 
                </div>               
            </v-tabs-window-item>            
        </v-tabs-window>
        <v-dialog v-if="pool.edit.show === true && pool.edit.model !== null" v-model="pool.edit.show" attach scrim opacity="0.6" max-width="60rem">
            <v-card style="max-width: 60rem;">
                <v-card-title class="bg-primary text-white pa-3">
                    Gericht bearbeiten
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="pa-0">
                        <v-row no-gutters>
                            <v-col>
                                <v-text-field v-model="pool.edit.model.Bezeichnung" label="Bezeichnung des Gerichts"/>
                            </v-col>
                        </v-row>
                        <v-row align="center" no-gutters>
                            <v-col cols="auto">
                                <v-switch v-model="pool.edit.model.Auswaerts" label="Auswärts essen" hide-details :disabled="pool.edit.model.LieferdienstAbholen === true"/>
                                <v-switch v-model="pool.edit.model.LieferdienstAbholen" label="Lieferdienst / abholen" hide-details :disabled="pool.edit.model.Auswaerts === true"/>                        
                            </v-col>
                            <v-col class="text-center">
                                <v-icon icon="mdi-star" role="button" size="3rem" @click="sterneSetzen(pool.edit.model, 1)"/>
                                <v-icon icon="mdi-star" role="button" size="3rem" v-if="pool.edit.model.Sterne >= 2" class="text-white ml-2" @click="sterneSetzen(pool.edit.model, 2)"/>
                                <v-icon icon="mdi-star" role="button" size="3rem" v-else class="ml-2 text-light opacity-50" @click="sterneSetzen(pool.edit.model, 2)"/>
                                <v-icon icon="mdi-star" role="button" size="3rem" v-if="pool.edit.model.Sterne == 3" class="text-white ml-2" @click="sterneSetzen(pool.edit.model, 3)"/>
                                <v-icon icon="mdi-star" role="button" size="3rem" v-else class="ml-2 text-light opacity-50" @click="sterneSetzen(pool.edit.model, 3)"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="bg-surface-lighten-1">
                    <v-btn color="success" text @click="gerichtSpeichern"><v-icon icon="mdi-check-circle" class="mr-2"/> Speichern</v-btn>
                    <v-btn color="error" text @click="pool.edit.show = false"><v-icon icon="mdi-cancel" class="mr-2"/> Abbrechen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="wizard.show === true" v-model="wizard.show" attach scrim opacity="0.6" max-width="60rem">
            <v-card :loading="wizard.isRunning" :disabled="wizard.isRunning">
                <v-card-title class="bg-primary text-white pa-3">
                    Gerichte für Tage einplanen
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="pa-0">
                        <v-row v-if="wizard.error !== null">
                            <v-col>
                                <v-alert type="error" closable>
                                    {{ wizard.error }}
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-date-input v-model="wizard.dateTo" label="Einplanen bis" hide-details display-format="fullDateWithWeekday" :picker-props="{ color: 'primary' }"/>
                            </v-col>
                            <v-col>
                                <v-switch v-model="wizard.replace" label="Vorhandene Gerichte überschreiben" hide-details/>
                            </v-col>                            
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="bg-surface-lighten-1">
                    <v-btn color="success" text @click="startWizard"><v-icon icon="mdi-check-circle" class="mr-2"/> Automatische Planung starten</v-btn>
                    <v-btn color="error" text @click="wizard.show = false"><v-icon icon="mdi-cancel" class="mr-2"/> Abbrechen</v-btn>
                </v-card-actions>                
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        name: 'kc-menuplan',
        data() {
            return {
                selectedTab: 'plan',
                tage: [],
                pool: {
                    show: false,
                    suche: '',
                    gerichte: [
                    ],
                    edit: {
                        show: false,
                        model: null,
                        isNew: false
                    }
                },
                wizard: {
                    show: false,
                    dateTo: null,
                    replace: false,
                    isRunning: false,
                    error: null
                }         
            }
        },
        computed: {
            poolGerichteGefiltert() {
                const vm = this;
                if (vm.pool.suche == '') {
                    return vm.pool.gerichte;
                }
                return vm.pool.gerichte.filter(g => g.Bezeichnung.toLowerCase().includes(vm.pool.suche.toLowerCase()));
            }
        },
        mounted() {
            const vm = this;
            vm.init();
        },
        methods: {
            init() {
                const vm = this;
                vm.wizard.dateTo = vm.$dayjs().add(14, 'day').toDate();
                vm.loadPool();
                let datum = vm.$dayjs();
                while(vm.tage.length < 15) {
                    vm.tage.push({
                        Id: datum.format('YYYY-MM-DD'),
                        Datum: datum.toDate(),
                        istWochenende: (datum.format('dd') == 'Sa' || datum.format('dd') == 'So'),
                        Gericht: null
                    });
                    datum = datum.add(1, 'day');
                }
            },
            loadPool() {
                const vm = this;
                let jsonPool = localStorage.getItem('kc_menu_plan_pool');
                if (jsonPool !== null) {
                    vm.pool.gerichte = JSON.parse(jsonPool);
                }
            },
            poolOeffnen() {
                const vm = this;
                vm.pool.show = true;
            },
            sterneSetzen(gericht, anzahl) {
                const vm = this;
                gericht.Sterne = anzahl;
                vm.savePool();
            },
            gerichtLoeschen(gericht) {
                const vm = this;
                let index = vm.pool.gerichte.indexOf(gericht);
                if (index >= 0) {
                    vm.pool.gerichte.splice(index, 1);
                    vm.savePool();                    
                }                
            },
            neuesGericht() {
                const vm = this;
                vm.pool.edit.model = {
                    Id: vm.generateUUID(),
                    Bezeichnung: '',
                    Auswaerts: false,
                    LieferdienstAbholen: false,
                    Sterne: 2
                };
                vm.pool.edit.isNew = true;
                vm.pool.edit.show = true;                
            },
            gerichtSpeichern() {
                const vm = this;
                if (vm.pool.edit.isNew === true) {
                    vm.pool.gerichte.push(vm.pool.edit.model);
                } else {
                    let gericht = vm.pool.gerichte.find(x => x.Id == vm.pool.edit.model.Id);
                    if (gericht) {
                        for(let prop in vm.pool.edit.model) {
                            gericht[prop] = vm.pool.edit.model[prop];
                        }
                    }
                }
                vm.pool.edit.show = false;
                vm.savePool();
            },
            gerichtBearbeiten(gericht) {
                const vm = this;
                let json = JSON.stringify(gericht);
                vm.pool.edit.model = JSON.parse(json);
                vm.pool.edit.isNew = false;
                vm.pool.edit.show = true;
            },
            savePool() {
                const vm = this;
                let json = JSON.stringify(vm.pool.gerichte);
                localStorage.setItem('kc_menu_plan_pool', json);                
            },
            generateUUID() { // Public Domain/MIT
                var d = new Date().getTime();//Timestamp
                var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16;//random number between 0 and 16
                    if(d > 0){//Use timestamp until depleted
                        r = (d + r)%16 | 0;
                        d = Math.floor(d/16);
                    } else {//Use microseconds since page-load if supported
                        r = (d2 + r)%16 | 0;
                        d2 = Math.floor(d2/16);
                    }
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },
            openWizard() {
                const vm = this;
                vm.wizard.show = true;
                vm.wizard.error = null;
            },
            startWizard() {

                const vm = this;                
                const wochenPlan = [];

                vm.wizard.isRunning = true;
                vm.wizard.error = null;
                
                let gerichte = vm.pool.gerichte;
                let anzahlTage = vm.$dayjs(vm.wizard.dateTo).diff(vm.$dayjs(), 'day') + 1;

                // Zähler für die aktuelle Woche (max. 1 pro Woche erlaubt)
                let auswaertsInDieserWoche = 0;
                let lieferdienstInDieserWoche = 0;

                // Speicher für die Gerichte der letzten 5 Tage
                const gesperrteGerichte = [];

                for (let tag = 0; tag < anzahlTage; tag++) {
                    // Zu Beginn jeder neuen Woche (alle 7 Tage) die Wochen-Zähler zurücksetzen
                    if (tag % 7 === 0) {
                        auswaertsInDieserWoche = 0;
                        lieferdienstInDieserWoche = 0;
                    }

                    // 1. Filtere die Gerichte nach allen Kriterien (Wochen-Limits UND 5-Tage-Sperre)
                    const erlaubteGerichte = gerichte.filter(g => {
                        if (g.Auswaerts && auswaertsInDieserWoche >= 1) return false;
                        if (g.LieferdienstAbholen && lieferdienstInDieserWoche >= 1) return false;
                        if (gesperrteGerichte.includes(g.Id)) return false; // 5-Tage-Sperre prüfen
                        return true;
                    });

                    // WICHTIG bei kleinen Listen: Falls durch die Filter kein Gericht übrig bleibt
                    if (erlaubteGerichte.length === 0) {
                        vm.wizard.error = `Sackgasse an Tag ${tag + 1}: Keine erlaubten Gerichte übrig. ` +
                            `Bei max. 20 Gerichten und harten Wochenlimits müssen genügend Standardgerichte (selbstgekocht) vorhanden sein.`;
                        vm.wizard.isRunning = false;
                        return;
                    }

                    // 2. Gewichteten Topf für den Zufallsgenerator erstellen
                    let gesamtGewicht = 0;
                    for (const g of erlaubteGerichte) {
                        gesamtGewicht += g.Sterne;
                    }

                    // 3. Zufallszahl ziehen
                    let zufallsZahl = Math.random() * gesamtGewicht;
                    let gewaehltesGericht = null;

                    for (const g of erlaubteGerichte) {
                        zufallsZahl -= g.Sterne;
                        if (zufallsZahl <= 0) {
                            gewaehltesGericht = g;
                            break;
                        }
                    }

                    // 4. Wochen-Zähler aktualisieren
                    if (gewaehltesGericht.Auswaerts) auswaertsInDieserWoche++;
                    if (gewaehltesGericht.LieferdienstAbholen) lieferdienstInDieserWoche++;

                    // 5. 5-Tage-Sperrliste aktualisieren
                    gesperrteGerichte.push(gewaehltesGericht.Id);
                    if (gesperrteGerichte.length > 5) {
                        gesperrteGerichte.shift(); // Ältestes Gericht nach 5 Tagen wieder freigeben
                    }

                    // 6. Dem Plan hinzufügen
                    wochenPlan.push({
                        Tag: tag + 1,
                        Woche: Math.floor(tag / 7) + 1,
                        Gericht: gewaehltesGericht,
                        Typ: gewaehltesGericht.Auswaerts ? 'Auswärts' : (gewaehltesGericht.LieferdienstAbholen ? 'Lieferdienst' : 'Selbstgekocht')
                    });
                }

                let datum = vm.$days();

                wochenPlan.forEach(p => {
                    let t = vm.tage.find(x => x.id == datum.format('YYYY-MM-DD'));
                    if (t) {
                        if (t.Gericht === null || vm.wizard.replace) {
                            t.Gericht = p.Gericht;
                        }
                    }
                });

                vm.wizard.isRunning = false;
                vm.wizard.show = false;
                
            }                        
        }
    }
</script>
<style scoped>

</style>